import { buildProps, definePropType, mutable } from '@bigin/utils'
import type { ExtractPropTypes } from 'vue'
import type Col from './col.vue'

export type ColSizeObject = {
  span?: number | string
  offset?: number
  order?: number | string
}
export type ColSize = number | string | ColSizeObject

export const colProps = buildProps({
  tag: {
    type: String,
    default: 'div',
  },
  span: {
    type: [Number, String],
    default: 0,
  },
  offset: {
    type: Number,
    default: 0,
  },
  order: {
    type: [Number, String],
    default: 0,
  },
  xs: {
    type: definePropType<ColSize>([Number, String, Object]),
    default: () => mutable({} as const),
  },
  sm: {
    type: definePropType<ColSize>([Number, String, Object]),
    default: () => mutable({} as const),
  },
  md: {
    type: definePropType<ColSize>([Number, String, Object]),
    default: () => mutable({} as const),
  },
  lg: {
    type: definePropType<ColSize>([Number, String, Object]),
    default: () => mutable({} as const),
  },
  xl: {
    type: definePropType<ColSize>([Number, String, Object]),
    default: () => mutable({} as const),
  },
  xxl: {
    type: definePropType<ColSize>([Number, String, Object]),
    default: () => mutable({} as const),
  },
} as const)
export type ColProps = ExtractPropTypes<typeof colProps>
export type ColInstance = InstanceType<typeof Col>
